export const DEAL_ASSIGNMENT_TYPES = {
  1: 'Contractor',
  2: 'Perm. Placement',
  3: 'Project'
}

export const CONTRACTOR = 1
export const PERMANENT_PLACEMENT = 2
export const PROJECT = 3
